import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, tap, timer } from 'rxjs';
import { AgentDto, AuthenticationWrapper, ForgotPasswordResetResponseDto, HierarchyDto, LoginRequestDto, LoginResponseDto, RolePermissionEnum } from './dto';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from './http-abstract.service';


@Injectable({
	providedIn: 'root'
})
export class AuthService extends AbstractHttpService {
	public authStateChange$ = new ReplaySubject<boolean>(1);
	authState?: AuthenticationWrapper;
	previousState: boolean | null = null;
	hasAccess: { [permission: string]: boolean } = {};
	hierarchy?: HierarchyDto;

	constructor(httpClient: HttpClient) {
		super(httpClient, '/api/auth', undefined);

		timer(0, 1000).subscribe(item => {
			this.syncAuth();
		});
	}
	private syncAuth() {
		const sAuthState = localStorage.getItem("authState");
		if (sAuthState == null) {
			this.authState = undefined;
			this.previousState = false;
			this.authStateChange$.next(false);
			return;
		}
		this.authState = JSON.parse(sAuthState) as AuthenticationWrapper;
		const currentState = this.isAuthenticated();
		if (this.previousState == null) {
			this.previousState = currentState;
			this.authStateChange$.next(currentState);
		} else if (this.previousState != currentState) {
			this.previousState = currentState;
			this.authStateChange$.next(currentState);
		}
	}


	public setHierarchy(hierarchy: HierarchyDto){
		this.hierarchy=hierarchy;
	}

	public doLogout() {
		// return super.doPostWithAuth<LoginResponseDto>(`/logout`, this.authState!.authToken!, {})
		// 	.subscribe(item => {
				localStorage.removeItem("authState");
				this.authState = undefined;
				this.previousState = false;
				this.authStateChange$.next(false);
			// });
	}
	public doAuthenticate(username: string, password: string, twoFactorToken: string): Observable<LoginResponseDto> {
		const payload: LoginRequestDto = {
			username: username,
			password: password,
			otp: twoFactorToken
		};
		return super.doPost<LoginResponseDto>(false, '/login', payload)
			.pipe(
				tap(item => {
					this.updateAuthenticate(item.success!, item.jwtToken!, item.expiresIn!, item.agent);
				})
			);
	}
	public updateAuthenticate(success: boolean, jwtToken: string, expiresIn: number, agent?: AgentDto) {
		if (success != true) {
			localStorage.removeItem("authState");
			this.authState = undefined;
			this.previousState = false;
			this.authStateChange$.next(false);
			return;
		}
		if (!agent) {
			agent = this.authState?.agent;
		}

		const authedState: AuthenticationWrapper = {
			expiresAt: Date.now() + (expiresIn! * 1000),
			agent: agent!,
			authToken: jwtToken!
		};
		localStorage.setItem("authState", JSON.stringify(authedState));
		this.syncAuth();
	}
	isAuthenticated(): boolean {
		if (this.authState == undefined) {
			return false;
		}
		return this.authState.expiresAt > Date.now();
	}
	getJwtToken(): string | null {
		if (this.isAuthenticated()) {
			return this.authState!.authToken;
		}
		return null;
	}

	//=====================================================
	public sendForgotPasswordOtp(username: string): Observable<any> {
		return super.doPost(false, `/forgot_password/${username}/otp`, username);
	}
	public doResetPasswordForForgotPassword(username: string, password: string, twoFactorToken: string): Observable<ForgotPasswordResetResponseDto> {
		const payload: LoginRequestDto = {
			username: username,
			password: password,
			otp: twoFactorToken
		};
		return super.doPost<ForgotPasswordResetResponseDto>(false, `/forgot_password/${username}/reset`, payload);
	}
	// public checkAgentState(agent: AgentDto): Observable<LoginResponseDto> {
	// 	const payload: LoginRequestDto = { username: agent.username };
	// 	return super.doPost(false, `/check_username`, payload);
	// }
	// public doCheckUsernameAndPassword(username: string, password: string): Observable<LoginResponseDto> {
	// 	const payload: LoginRequestDto = {
	// 		username: username,
	// 		password: password
	// 	};
	// 	return super.doPost<LoginResponseDto>(false, '/check_username_and_password', payload);
	// }
	// public doCheckUsernameAndOtpForForgotPassword(username: string, otp: string): Observable<LoginResponseDto> {
	// 	const payload: LoginRequestDto = {
	// 		username: username,
	// 		twoFactorCode: otp
	// 	};
	// 	return super.doPost<LoginResponseDto>(false, '/check_username_and_otp_for_forgot_password', payload);
	// }
	// public hasPermission(input: RolePermissionEnum): boolean {
	// 	if (this.authState?.agent?.roles.flatMap(role => role.permissions ?? []).filter(i => i.selected == true).map(i => i.permission).indexOf(input) != -1) {
	// 		return true;
	// 	}
	// 	return false;
	// }
	// ===========================================================
	// public doSendLoginOtp(username: string, forceNew: boolean, channel?: AgentOtpChannelEnum): Observable<SentOtpDto>{
	// 	if(channel){
	// 		return super.doPost<SentOtpDto>(false, `/send_login_otp?forceNew=${forceNew}&channel=${channel}`, { username: username });
	// 	}else{
	// 		return super.doPost<SentOtpDto>(false, `/send_login_otp?forceNew=${forceNew}`, { username: username });
	// 	}
	// }
	// public doSendForgotPasswordOtp(username: string, forceNew:boolean, channel?: AgentOtpChannelEnum): Observable<SentOtpDto>{
	// 	if(channel){
	// 		return super.doPost<SentOtpDto>(false, `/send_forgot_password_otp?forceNew=${forceNew}&channel=${channel}`, { username: username });
	// 	}else{
	// 		return super.doPost<SentOtpDto>(false, `/send_forgot_password_otp?forceNew=${forceNew}`, { username: username });
	// 	}
	// }
	// public getRegistrationOtpDetailsAndResend(username: string, channel?: AgentOtpChannelEnum): Observable<SentOtpDto>{
	// 	if(channel){
	// 		return super.doPost<SentOtpDto>(false, `/send_registration_otp?channel=${channel}`, { username: username });
	// 	}else{
	// 		return super.doPost<SentOtpDto>(false, `/send_registration_otp`, { username: username });
	// 	}
	// }
}
